/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
export class ContentRef {
    constructor(/* tslint:disable-next-line: no-any */
    /* tslint:disable-next-line: no-any */
    nodes, viewRef, /* tslint:disable-next-line: no-any */
    /* tslint:disable-next-line: no-any */
    componentRef) {
        this.nodes = nodes;
        this.viewRef = viewRef;
        this.componentRef = componentRef;
    }
}
//# sourceMappingURL=content-ref.class.js.map